import { useState } from "react";
import * as styled from "./AdminShop.styled";

const KINDS = [
  { value: "discount", label: "Знижка" },
  { value: "free_lesson", label: "Безкоштовний урок" },
  { value: "gift_friend", label: "Подарунок другу (просить телефон друга)" },
  { value: "other", label: "Інше" },
];

// Картка редагування товару. isNew — порожня картка для додавання.
function ShopItemEditor({ item, onSave, onDelete, isNew }) {
  const [form, setForm] = useState(item);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);

  const set = (field) => (event) => {
    const value = event.target.type === "checkbox" ? event.target.checked : event.target.value;
    setForm((prev) => ({ ...prev, [field]: value }));
    setMessage(null);
  };

  const handleSave = async () => {
    if (!form.title.trim() || Number(form.priceStars) < 1) {
      setMessage("Потрібні назва і ціна від 1 ⭐");
      return;
    }
    setSaving(true);
    try {
      await onSave({
        ...form,
        priceStars: Number(form.priceStars),
        limitPerOwner: Number(form.limitPerOwner),
        sortOrder: Number(form.sortOrder),
      });
      if (isNew) setForm(item);
      setMessage("Збережено");
    } catch (error) {
      setMessage(error.response?.data?.message || "Не вдалося зберегти");
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm(`Видалити товар «${form.title}»? Учні більше не побачать його в магазині.`)) return;
    setSaving(true);
    try {
      await onDelete(item._id);
    } catch (error) {
      setMessage(error.response?.data?.message || "Не вдалося видалити");
      setSaving(false);
    }
  };

  return (
    <styled.ItemCard $inactive={!form.active}>
      <styled.ItemHeader>{isNew ? "Новий товар" : form.title}</styled.ItemHeader>
      <styled.Field>
        Назва
        <styled.Input value={form.title} onChange={set("title")} />
      </styled.Field>
      <styled.Field>
        Опис для учня
        <styled.TextArea value={form.description} onChange={set("description")} rows={2} />
      </styled.Field>
      <styled.FieldRow>
        <styled.Field>
          Ціна, ⭐
          <styled.Input type="number" min="1" value={form.priceStars} onChange={set("priceStars")} />
        </styled.Field>
        <styled.Field>
          Ліміт на учня (0 — без ліміту)
          <styled.Input type="number" min="0" value={form.limitPerOwner} onChange={set("limitPerOwner")} />
        </styled.Field>
        <styled.Field>
          Порядок
          <styled.Input type="number" value={form.sortOrder} onChange={set("sortOrder")} />
        </styled.Field>
      </styled.FieldRow>
      <styled.FieldRow>
        <styled.Field>
          Тип
          <styled.Select value={form.kind} onChange={set("kind")}>
            {KINDS.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </styled.Select>
        </styled.Field>
        <styled.Checkbox>
          <input type="checkbox" checked={form.active} onChange={set("active")} />
          Показувати учням
        </styled.Checkbox>
      </styled.FieldRow>
      <styled.Actions>
        <styled.Button onClick={handleSave} disabled={saving}>
          {isNew ? "Додати" : "Зберегти"}
        </styled.Button>
        {!isNew && (
          <styled.GhostButton onClick={handleDelete} disabled={saving}>
            Видалити
          </styled.GhostButton>
        )}
        {message && <styled.RowMeta>{message}</styled.RowMeta>}
      </styled.Actions>
    </styled.ItemCard>
  );
}

export default ShopItemEditor;
